import React, { useState, useEffect } from 'react';

let toastId = 0;
const toastCallbacks = new Set();

export const toast = {
  success: (message, options = {}) => {
    const id = ++toastId;
    const toastData = {
      id,
      type: 'success',
      message,
      duration: options.duration || 4000,
      position: options.position || 'top-center'
    };
    
    toastCallbacks.forEach(callback => callback(toastData));
    
    setTimeout(() => {
      toastCallbacks.forEach(callback => callback({ id, remove: true }));
    }, toastData.duration);
  }
};

export const Toaster = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const callback = (toastData) => {
      if (toastData.remove) {
        setToasts(prev => prev.filter(t => t.id !== toastData.id));
      } else {
        setToasts(prev => [...prev, toastData]);
      }
    };

    toastCallbacks.add(callback);
    return () => toastCallbacks.delete(callback);
  }, []);

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 space-y-2">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`px-6 py-3 rounded-lg shadow-lg text-white font-medium transition-all duration-300 ${
            toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          }`}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
};
